export enum ReviewInteractionType {
  NONE = 'none',
  REMINDER = 'reminder',
  REMINDER_CHECK = 'reminderCheck',
  REPLY = 'reply',
  REPLY_CHECK = 'replyCheck',
  REPLY_OUTDATED = 'replyOutdated',
}
